import * as UI from "@accurx/design";
import styled from "styled-components";

export const StyledPopoverContent = styled(UI.PopoverContent)`
    width: calc(100vw - calc(2rem));
    height: 100%;

    transition: max-height 1.15s ease-out;

    // override PopoverContent padding & styling
    max-height: initial;
    padding: 0px;
    border: 1px solid var(--ds-color-silver);

    > ul {
        height: 100%;
        max-height: min(var(--radix-popper-available-height), 400px);
        display: flex;
        flex-direction: column;
        position: relative;

        @media screen and (min-width: ${UI.Tokens.BREAKPOINTS.sm}) {
            max-height: var(--radix-popper-available-height);
        }
    }

    @media screen and (min-width: ${UI.Tokens.BREAKPOINTS.sm}) {
        width: 405px;
        height: 50vh;
    }
`;

export const StyledErrorContainer = styled.div`
    padding: 1rem 0 2.5rem 0;
`;
